export const BLACK = "#282828";
export const PRIMARY = "#4644FD";
export const LIGHT_PRIMARY = "#A9A9F7";
export const LIGHT_GREY = "#F7F7F7";
export const LIGHTEST_PRIMARY = "#DFDEFF";
export const MEDIUM_GREY = "#DDDDDD";
export const WHITE = "#ffffff";
export const DARK_PRIMARY = "#2C2BA3";
